var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'SideBySideCmp',
    { intersected: _vm.intersected, imgContain: _vm.contain } ]},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row flex-column flex-md-row align-items-md-center position-relative"},[(
          _vm.themeVariant.includes('image-left') ||
          _vm.xsOnly ||
          (_vm.mdAndDown && _vm.themeVariant.includes('signature'))
        )?_c('div',{class:[
          'col-12',
          {
            'col-md-5':
              !_vm.themeVariant.includes('with-carousel') &&
              !_vm.themeVariant.includes('signature'),
            'col-md-6 col-lg-5': _vm.themeVariant.includes('with-carousel'),
            'col-lg-6': _vm.themeVariant.includes('image-sticky'),
            'offset-md-1':
              !_vm.themeVariant.includes('image-sticky') &&
              !_vm.themeVariant.includes('with-carousel'),
            'offset-lg-1': _vm.themeVariant.includes('with-carousel'),
            'col-md-10 col-lg-5': _vm.themeVariant.includes('signature'),
          } ]},[_c('div',{staticClass:"image-container"},[(
              _vm.themeVariant.includes('with-carousel') &&
              _vm.themeVariant.includes('product-detail-variant')
            )?_c('slider-cmp-extended',{attrs:{"data-bootstrap-container-classes":['container-fluid', 'px-0'],"data-component-slides":true,"data-options":{
              observer: true,
              slidesPerView: 1,
              enabled: _vm.$slots.carousel.length === 1 ? false : true,
            }},on:{"active-index-change":function($event){_vm.productDetailSliderIndex = $event}},nativeOn:{"click":function($event){return _vm.onProductDetailSliderClick($event)}},scopedSlots:_vm._u([{key:"components",fn:function(){return [_vm._t("carousel")]},proxy:true}],null,true)}):_vm._e(),(
              _vm.themeVariant.includes('with-carousel') &&
              _vm.themeVariant.includes('product-detail-variant')
            )?_c('button',{staticClass:"product-detail-zoom-btn",on:{"click":function($event){return _vm.$emit('product-image-click', _vm.productDetailSliderIndex)}}},[_c('svg',[_c('use',{attrs:{"href":"#icon-plus"}})])]):(_vm.themeVariant.includes('with-carousel'))?_c('slider-cmp-extended',{attrs:{"data-bootstrap-container-classes":['container-fluid', 'px-0'],"data-component-slides":true,"data-options":{
              observer: true,
              slidesPerView: 1,
              navigation: false,
              enabled: _vm.$slots.carousel.length === 1 ? false : true,
            }},scopedSlots:_vm._u([{key:"custom-swipe-icon",fn:function(){return [_c('svg',[_c('use',{attrs:{"href":"#icon-scroller"}})])]},proxy:true},{key:"components",fn:function(){return [_vm._t("carousel")]},proxy:true}],null,true)}):_c('figure',{class:['side-image', _vm.dataShadowClass]},[_vm._t("image")],2)],1)]):_vm._e(),_c('div',{class:[
          'col-12',
          {
            'col-md-6 col-lg-5': _vm.themeVariant.includes('image-sticky'),
            'col-md-5':
              !_vm.themeVariant.includes('image-sticky') &&
              !_vm.themeVariant.includes('with-carousel') &&
              !_vm.themeVariant.includes('signature'),
            'col-md-6 col-lg-5 col-xl-4 offset-xl-1':
              _vm.themeVariant.includes('with-carousel'),
            'offset-md-1':
              _vm.themeVariant.includes('image-right') &&
              !_vm.themeVariant.includes('with-carousel') &&
              !_vm.themeVariant.includes('signature'),
            'offset-lg-1':
              _vm.themeVariant.includes('image-right') &&
              _vm.themeVariant.includes('with-carousel'),
            'col-md-10 offset-md-1 col-lg-5':
              _vm.themeVariant.includes('signature'),
            'offset-lg-0':
              _vm.themeVariant.includes('image-left') &&
              _vm.themeVariant.includes('signature'),
          } ]},[_c('div',{staticClass:"text-container"},[_vm._t("default"),(_vm.themeVariant.includes('signature'))?_c('div',{staticClass:"signature-wrapper a-support text-color-bronze font-medium"},[_c('div',{staticClass:"quote-wrapper"},[_c('div',{staticClass:"font-bold"},[_vm._t("quote-author")],2),_vm._t("quote-author-restaurant")],2),_c('div',{staticClass:"signature-image-wrapper"},[_vm._t("signature-image")],2)]):_vm._e()],2)]),(
          _vm.themeVariant.includes('image-right') &&
          ((_vm.mdAndUp && !_vm.themeVariant.includes('signature')) ||
            (_vm.lgAndUp && _vm.themeVariant.includes('signature')))
        )?_c('div',{class:[
          {
            'col-md-5':
              !_vm.themeVariant.includes('with-carousel') &&
              !_vm.themeVariant.includes('signature'),
            'col-md-6 col-lg-5 offset-xl-1':
              _vm.themeVariant.includes('with-carousel'),
            'col-lg-6': _vm.themeVariant.includes('image-sticky'),
            'col-lg-5': _vm.themeVariant.includes('signature'),
          } ]},[_c('div',{staticClass:"image-container"},[(_vm.themeVariant.includes('with-carousel'))?_c('slider-cmp-extended',{attrs:{"data-bootstrap-container-classes":['container-fluid', 'px-0'],"data-component-slides":true,"data-options":{
              observer: true,
              slidesPerView: 1,
              navigation: false,
              enabled: _vm.$slots.carousel.length === 1 ? false : true,
            }},scopedSlots:_vm._u([{key:"custom-swipe-icon",fn:function(){return [_c('svg',[_c('use',{attrs:{"href":"#icon-scroller"}})])]},proxy:true},{key:"components",fn:function(){return [_vm._t("carousel")]},proxy:true}],null,true)}):_c('figure',{class:['side-image', _vm.dataShadowClass]},[_vm._t("image")],2)],1)]):_vm._e(),(_vm.themeVariant.includes('animated'))?_c('div',{directives:[{name:"intersect",rawName:"v-intersect.once",value:(_vm.onIntersect),expression:"onIntersect",modifiers:{"once":true}}],staticClass:"intersect"}):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }